import React from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image';

import BadgeLabel from '../label/BadgeLabel';
import TimeLabel from '../label/TimeLabel';
import PlayLabel from '../label/PlayLabel';
import NewLabel from '../label/NewLabel';
import { getFormatDate } from '../../../common/utils/convertUtil';
// free_part_yn :
export default function Box (props) {
  const router = useRouter();

  const imgUrl = props.img || 'https://via.placeholder.com/384x216?text=SBS';// TODO 라이브 일때 호출(scret) 다르게 해야함
  let boxWrapperName;
  let boxType;

  let relateId = props.relateId;
  const relateTitle = props.relateTitle;
  const relateTitleViewYn = props.relateTitleViewYn;
  let relateType = props.relateType;

  let type;
  if (props.type === undefined || props.type === 'thumb') {
    if (props.progress) {
      type = '1';
    }
    if (props.bold) {
      type = '2';
    }
    if (props.info && props.info.date) {
      type = '3';
    } else if (props.info.title && !props.info.desc) {
      type = '4';
    } else if (props.info && props.info.ep && props.info.date) {
      type = '5';
    } else if (props.info.title && props.info.desc) {
      type = '6';
      if (props.info.pgm_title) {
        type = '1';
      } else if (props.info.pgm_tms_title) {
        type = '2';
      }
    }
  } else {
    type = props.type;
  }

  switch (props.type) {
    case 'poster':
      boxWrapperName = 'post_box_w';
      boxType = 'pb';
      break;
    case 'schedule':
      boxWrapperName = 'schedule_box_w';
      boxType = 'sb';
      break;
    case 'event':
      boxWrapperName = 'module_box_w_type8';
      boxType = 'mb';
      break;
    case 'thumb':
      boxWrapperName = `module_box_w_type${type}`;
      boxType = 'mb';
      break;
    case 'type':
    default:
      boxWrapperName = `module_box_w_type${type}`;
      boxType = 'mb';
      break;
  }

  // new_vod
  if (props.bottom_type === 'top_clip') {
    relateId = 'top_clip';
    relateType = 'top_clip';
  } else if (props.bottom_type === 'live') {
    relateId = 'live';
    relateType = 'live';
  } else if (props.bottom_type === 'new_vod') {
    relateId = 'new_vod';
    relateType = 'new_vod';
  }

  // TODO : 이벤트 추가

  // 검수시 QA 에포함 되어있는 내용(기획서 내용에도 있음)
  const srsCheck = props.srs_div;
  const srsDiv = props.srs_div;
  const srsNo = props.srs_no;
  const srsDtlNo = props.srs_dtl_no;
  if (relateId != null) {
    if (relateType === 'vod') {
      //   - relate_type: "vod" > 회차구분(srs_div) + 회차 (content_num), 부제 (title), 방송일 (content_date), 썸네일 아이콘 (19, free)
      if (srsDiv != null) {
        boxWrapperName = 'module_box_w_type3';
        type = '3';
        if (srsDiv === '03') {

          // srs_div
          //    ※ 회차구분 표시 : srs_div 가 03 인 경우 스페셜
          //   ex) 스페셜 1회 히든룸 끝의 시작
          //       2021.06.02
        } else if (srsDiv === '04') {

          // 04 인 경우 파일럿 (01 정규, 02 예고 는 표시하지 않음)
          //   ex) 파일럿 1회 히든룸 끝의 시작
          //         2021.06.02
        }
      }
    } else if (relateType === 'clip') {
      boxWrapperName = 'module_box_w_type4';
      type = '4';
      //   - relate_type: "clip" > 콘텐츠 내용 (title), 썸네일 아이콘 (19, 플레이시간)
    } else if (relateType === 'curation_clip') {
      //   - relate_type: "curation_clip" > 콘텐츠 내용(title), 프로그램명
    } else if (relateType === 'curation_program') {
      boxWrapperName = 'module_box_w_type6';
      type = '6';
      //   - relate_type: "curation_program" > 프로그램 내용 (title), 프로그램명
    } else if (relateType === 'curation_free') {
      boxWrapperName = 'module_box_w_type4';
      type = '4';
      //   - relate_type: "curation_free" > 콘텐츠 내용 (title)
    } else if (relateType === 'curation_vod') {
      boxWrapperName = 'module_box_w_type5';
      type = '5';
    } else if (relateType === 'top_clip' || relateType === 'clip_new') {
      boxWrapperName = 'module_box_w_type7';
      type = '7';
    } else if (relateType === 'live') {
      boxWrapperName = 'module_box_w_type1';
      type = '1';
    } else if (relateType === 'new_vod') {
      boxWrapperName = 'module_box_w_type5';
      type = '5';
    }
  }

  const progressbarPercent = (props?.progress?.percent > -1 ? props.progress.percent : 0) + '%';
  const progressbarStatus = props?.progress?.status || '진행 중';

  const free = props?.data?.isfree;
  const labelObj = { // TODO childmild ...........   childmild   free 티비섹션  무료 부분 ----------------------------------------
    type: boxType,
    data: props.label,
    time: props.time,
    play: props.play,
    free: free
  };

  let ariaBoxLabel = '';
  (Array.isArray(props.label) ? props.label : [props.label]).map((item, index) => {
    if (item.type === 'free') {
      ariaBoxLabel += '라이브 무료, ';
    } else if (item.type === 'bora') {
      ariaBoxLabel += '보는라디오, ';
    } else if (item.type === '19') {
      ariaBoxLabel += '19세 제한, ';
    }
  });

  let linkUrl = `${props.link || props.link_url || '#'}`;
  if (props.clickParams) {
    const key = props.clickParams.split('=')[0];
    const value = props.clickParams.split('=')[1];

    if (linkUrl.indexOf('http') === -1) {
      router.query[key] = value;

      let parameter = Object.keys(router.query).map(function (x) {
        if (encodeURIComponent(x) !== 'channelID') {
          return encodeURIComponent(x) + '=' + encodeURIComponent(router.query[x]);
        }
      }).join('&');
      const queryArray = parameter.match(/=/g);
      if (queryArray && queryArray.length === 1) {
        parameter = parameter.replace('&', '');
      }
      linkUrl = `${linkUrl}?${parameter}`;
    } else {
      const httpUrl = new URL(linkUrl);
      httpUrl.searchParams.set(key, value);

      linkUrl = httpUrl.toString();
    }
  }

  return (
    <>
      {props.type !== 'schedule' && (
        <div className={boxWrapperName}>
          <a
            href={`${linkUrl}`}
            target={(props.link_new_yn === 'Y' ? '_blank' : '')}
            onClick={() => {
              if (linkUrl.indexOf('/live/') > -1) {
                window.location.href = linkUrl;
              }
            }}
            tabIndex={(props.view ? '0' : '-1')} className={`${boxType}_link`} aria-label={ariaBoxLabel +
                (props.type === 'poster' ? '프로그램, ' : '') +
                (props.time && props.time ? `${props.time} 길이` : '') +
                (props.play ? '클립영상, ' : '') +
                `${props.info.title}, ` +
                (props.info && props.info.ep ? `${props.info.ep} ` : '') +
                (props.info && props.info.date ? `${props.info.date} ` : '') +
                (props.info && props.info.desc ? `${props.info.desc} ` : '') +
                (props.progress && props.progress.percent ? `라이브 채널 ${progressbarPercent} 재생 중` : '')}
          >
            <div className={`${boxType}_image_w`}>
              <div className={`${boxType}_image_inner`}>

                {/* TODO childmild 무료 확인하기  poster badge 확인  tv_poster 값이 넘어오지 않음 =============> */}
                {/* {relateType === 'tv_poster' && (<div className='mb_label_w'><span className='mb_label_free'>무료</span></div>)} */}
                {props.isfree === 'Y' && relateType === 'tv_free' && (<div className='mb_label_w'><span className='mb_label_partfree' title='부분무료'>부분무료</span></div>)}
                <div className={`${boxType}_image`} style={{ width: '100%' }}>
                  <Image
                    src={imgUrl}
                    alt={props.info.title + ' 이미지'}
                    layout='fill'
                    quality={props.imageQuality || 75}
                  />
                </div>
              </div>

              {props?.progress?.percent > -1 && (
                <div className={`${boxType}_progress_w`}>
                  <i className='hide'>라이브 총시간 및 진행시간</i>
                  <span className={`${boxType}_progress`} style={{ width: progressbarPercent }} title={progressbarStatus} />
                </div>)}

              {relateType === 'vod' && (<BadgeLabel {...labelObj} />)}
              {relateType === 'curation_vod' && (<BadgeLabel {...labelObj} />)}
              {relateType === 'new_vod' && (<BadgeLabel {...labelObj} />)}

              {props.label.filter(x => x.type === 'bora') && (<BadgeLabel {...labelObj} />)}

              {relateType === 'vod' && (<PlayLabel />)}
              {relateType === 'curation_vod' && (<PlayLabel />)}
              {relateType === 'new_vod' && (<PlayLabel />)}
              {props.bottom_type === 'live_recommand_clip' && props.play && (<PlayLabel />)}

              {/* 해당 부분 확인해보기 */}
              {relateType === 'clip_new' && (<TimeLabel text={props.time} />)}
              {relateType === 'top_clip' && (<TimeLabel text={props.time} />)}
              {relateType === 'curation_clip' && (<TimeLabel text={props.time} />)}
              {relateType === 'clip' && (<TimeLabel text={props.time} />)}
              {props.bottom_type === 'live_recommand_clip' && props.time && (<TimeLabel text={props.time} />)}

              {/* 하단 인기 clip 노출 요소 >  콘텐츠내용 2줄 ( title), 프로그램명 1줄
              - ex)  김원효×이상훈’ 다비쳐, 데뷔곡
                <HOT COOL SEXY> 무대 공개!
                모닝와이드 3부 */}

            </div>

            {props.type !== 'poster' && relateType === 'vod' &&
                (
                  <div className='mb_info_w'>
                    {srsCheck === '03' && (<span className='mbif_title'>스페셜 {props.content_num}회 {props.content}</span>)}
                    {srsCheck === '04' && (<span className='mbif_title'>파일럿 {props.content_num}회 {props.content}</span>)}
                    {srsCheck !== '03' && srsCheck !== '04' && (<span className='mbif_title'>{props.content_num}회 {props.content}</span>)}

                    <span className='mbif_date'>{getFormatDate(props.content_date)}</span>
                  </div>
                )}

            {props.type !== 'poster' && relateType === 'curation_vod' &&
                (
                  <div className={`${boxType}_info_w`}>
                    <span className={`${boxType}if_title`}>{props.info.title}</span>
                    <div className='mb_infoline_inner'>
                      {srsCheck === '03' && (<span className='mbif_ep'>스페셜 {props.srs_no}회 </span>)}
                      {srsCheck === '03' && (<span className='mbif_date'>{getFormatDate(props.content_date)}</span>)}
                      {srsCheck === '04' && (<span className='mbif_ep'>파일럿 {props.srs_no}회 </span>)}
                      {srsCheck === '04' && (<span className='mbif_date'>{getFormatDate(props.content_date)}</span>)}

                      {srsCheck !== '03' && srsCheck !== '04' && (<span className='mbif_ep'>{props.srs_no}회 </span>)}
                      {srsCheck !== '03' && srsCheck !== '04' && (<span className='mbif_date'>{getFormatDate(props.content_date)}</span>)}
                    </div>
                  </div>
                )}

            {props.type !== 'poster' && relateType === 'clip' &&
                (
                  <div className={`${boxType}_info_w`}>
                    {props.info && props.info.title && (<span className={`${boxType}if_title`}>{props.title}</span>)}

                  </div>
                )}
            {props.type !== 'poster' && relateType === 'clip_new' &&
                (
                  <div className={`${boxType}_info_w`}>
                    {props.info && props.info.title && (<span className={`${boxType}if_title`}>{props.data.title}</span>)}
                    {/* {props.info && props.info.title && (<span className='mbif_subinfo'>{props.data.pgm_nm}</span>)} */}
                  </div>
                  // <div className={`${boxType}_info_w`}>
                  //   {props.info && props.info.title && (<span className={`${boxType}if_title`}>{props.title}</span>)}

            // </div>
                )}

            {props.type !== 'poster' && relateType === 'curation_clip' &&
                (
                  <div className={`${boxType}_info_w`}>
                    {props.info && props.info.title && (<span className={`${boxType}if_title`}>{props.title}</span>)}
                    {props.info && props.info.title && (<span className='mbif_subinfo'>{props.info.title}</span>)}

                  </div>
                )}

            {props.type !== 'poster' && relateType === 'curation_program' &&
                (
                  <div className={`${boxType}_info_w`}>
                    {props.info && props.info.title && (<span className={`${boxType}if_title`}>{props.title}</span>)}
                    {props.info && props.info.title && (<span className='mbif_subinfo'>{props.info.title}</span>)}

                  </div>
                )}

            {props.type !== 'poster' && relateType === 'curation_free' &&
                (

                  <div className={`${boxType}_info_w`}>
                    {props.info && props.info.title && (<span className={`${boxType}if_title`}>{props.title}</span>)}

                  </div>

                )}

            {props.type !== 'poster' && relateType === 'top_clip' &&
                (
                  <div className={`${boxType}_info_w`}>
                    {/* {props.info && props.info.title && (<span className={`${boxType}if_title`}>{props.info.title}</span>)}  //확인 */}
                    {props.info && props.info.title && (<span className={`${boxType}if_title`}>{props.data.title}</span>)}
                    {props.info && props.info.title && (<span className='mbif_subinfo'>{props.data.pgm_nm}</span>)}
                    {/* pgm_nm */}
                  </div>
                )}

            {props.type !== 'poster' && relateType === 'live' &&
                (
                  <div className={`${boxType}_info_w`}>
                    {props.info && props.info.title && (<span className='mbif_title'>{props.info.title}</span>)}
                    {props.info && props.info.title && (<span className='mbif_subinfo'>{props.info.desc}</span>)}

                  </div>
                )}

            {props.type !== 'poster' && relateType === 'new_vod' &&
                (
                  <div className={`${boxType}_info_w`}>
                    <span className={`${boxType}if_title`}>{props.data.pgm_nm}</span>
                    <div className='mb_infoline_inner'>
                      {srsCheck === '03' && (<span className='mbif_ep'>스페셜 {props.data.content_num}회 </span>)}
                      {srsCheck === '03' && (<span className='mbif_date'>{getFormatDate(props.data.content_date)}</span>)}
                      {srsCheck === '04' && (<span className='mbif_ep'>파일럿 {props.data.content_num}회 </span>)}
                      {srsCheck === '04' && (<span className='mbif_date'>{getFormatDate(props.data.content_date)}</span>)}

                      {srsCheck !== '03' && srsCheck !== '04' && (<span className='mbif_ep'>{props.data.content_num}회 </span>)}
                      {srsCheck !== '03' && srsCheck !== '04' && (<span className='mbif_date'>{getFormatDate(props.data.content_date)}</span>)}
                    </div>
                  </div>
                )}

            {props.type !== 'poster' && !relateType && (
              <div className={`${boxType}_info_w`}>
                {props.info && props.info.title && (<span className={`${boxType}if_title`}>{props.info.title}</span>)}
                {props.info && props.info.ep && !props.info.date && (<span className={`${boxType}if_ep`}>{props.info.ep}</span>)}
                {props.info && props.info.date && !props.info.ep && (<span className={`${boxType}if_date`}>{props.info.date}</span>)}
                {props.info && props.info.desc && (<span className={`${boxType}if_subinfo`}>{props.info.desc}</span>)}
              </div>)}

            {props.type === 'poster' && (
              <div className={`${boxType}_info_w`}>
                {/* 내가 본 프로그램 에서하단 타이틀 비노출 되는 문제 해결하기 */}
                {props.data && (<span className={`${boxType}if_title`}>{props.data.pgm_nm}</span>)}
                {props.isNew && <NewLabel />}
              </div>
            )}

          </a>
        </div>
      )}
      {props.type === 'schedule' && (
        <div tabIndex={(props.view ? '0' : '-1')} aria-label={`${props.info.title}, 방송시간: ${props.info.desc}`} className={`schedule_box_w ${props.current ? 'current' : ''}`}>
          <div className='schedule_box_inner'>
            <div className='schedule_box_title'>
              <p>{props.info.title}</p>
            </div>
            <div className='schedule_box_time'>{props.info.desc}</div>

            {props?.progress?.percent > -1 && (
              <div className='schedule_box_progress_w'>
                <i className='hide'>라이브 총시간 및 진행시간</i>
                <span className={`${boxType}_progress`} style={{ width: progressbarPercent }} title={progressbarStatus} />
              </div>)}

            <div className='round_label_red'>
              <span className='round_ltc_text'>라이브</span>
            </div>
          </div>
        </div>)}
    </>
  );
}
